module.exports = __webpack_public_path__ + "overseer_frontend_mobile/img/red_index.814e6140.png";